// extracted by mini-css-extract-plugin
export var typewriter = "stuff-module--typewriter--dYOba";